<header>
  <div class="header_top d-flex jc-end">
    <div class="header_top__right">
      <div class="date">
        <p>{{ "header.minsk" | translate }}:</p>
        <p>
          {{ formattedDate }}, 
          {{ formattedTime }}
        </p>
      </div>
      <div style="padding-left: 10px">
        <dx-drop-down-button
          [items]="language"
          [text]="selectLang"
          keyExpr="value"
          width="70px"
          displayExpr="name"
          (onItemClick)="changeLang($event)"
        >
        </dx-drop-down-button>
      </div>
    </div>
  </div>
  <div class="header_top-line d-flex jc-sb ai-c">
    <div class="header_top-line__left d-flex ai-c">
      <div
        class="logo"
        routerLink="/"
        *ngIf="'header.top_line.logo' | translate"
      >
        <img
          alt="logo"
          src="assets/img/{{ 'header.top_line.logo' | translate }}.svg"
        />
      </div>
      <nav class="main_nav" (click)="$event.stopPropagation()">
        <ul class="d-flex">
          <!-- HOME -->
          <li [ngClass]="{ active: getLocation('/') }">
            <a
              [href]="getMainUrl()"
              target="_self"
              (click)="goToMain($event)">
              <span class="mainActiveColor">
                {{"general.homePage" | translate}}</span>
            </a>
          </li>

          <!-- CATALOG -->
          <li #catalog>
            <div (click)="toggleMenu('catalog')">
              {{ "header.top_line.menu.catalog" | translate }}
            </div>
            <div *ngIf="activeMenu === 'catalog'">
              <div class="flexContentColumn4 first-submenu">
                <ul class="flexContentColumn4">
                  <li class="blackColor">
                    <a
                      [href]="getCatalogUrl(1)"
                      target="_self"
                      (click)="$event.stopPropagation()">
                      {{ "header.top_line.menu.demandCatalog" | translate }}
                    </a>
                  </li>
                  <li class="blackColor">
                    <a
                      [href]="getCatalogUrl(2)"
                      target="_self"
                      (click)="$event.stopPropagation()">
                      {{"header.top_line.menu.offersCatalog" | translate}}
                    </a>
                  </li>
                  <li *ngIf="user?.token && isAcceptableRole()" >
                    <a
                      [href]="getPersonalPageCatalogueUrl()"
                      target="_self"
                      (click)="$event.stopPropagation()"
                      class="blackColor">
                      {{ "header.top_line.menu.goodsCatalog" | translate }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <!-- SESSIONS -->
          <li *ngIf="!user?.token || !this.user.IsWorker" >
            <a
              [href]="strSessionShedule"
              target="_self"
              (click)="$event.stopPropagation()">
              {{ "header.top_line.menu.sessionsSchedule" | translate }}
            </a>
          </li>
          <li #session *ngIf="user?.IsWorker">
            <div (click)="toggleMenu('sessions')">
              {{ "header.top_line.menu.sessions" | translate }}
            </div>
            <div *ngIf="activeMenu === 'sessions'">
              <div class="flexContentColumn4 first-submenu">
                <ul class="flexContentColumn4">
                  <li
                    *ngIf="
                      DemandOfferManagementGetPrivilegus ||
                      DemandOfferManagementEditPrivilegus"
                    class="blackColor">
                    <a
                      class="mainTextColor d-flex w-100"
                      [href]="strSessionShedule"
                      target="_self"
                      (click)="$event.stopPropagation()">
                      {{"header.top_line.menu.sessionsSchedule" | translate}}</a>
                  </li>
                  <li #subsession
                      *ngIf="CompositeSesManNewPrivilegus">
                  <div (click)="toggleSubMenu('sessionsNts')"
                       class="blackColor flexContent8 pr-1 subItem">
                    <span>{{ "header.top_line.menu.sessionManNts" | translate }}</span>
                    <i class="filtersArrow tr-rt90"></i>
                  </div>
                    <ul class="second-submenu sessions"
                        *ngIf="activeSubMenu === 'sessionsNts'">
                      <li class="blackColor">
                        <a
                          [href]="strSessions"
                          target="_self"
                          (click)="$event.stopPropagation()"
                          class="mainTextColor d-flex w-100">
                          {{ "header.top_line.menu.sessions" | translate }}
                        </a>
                      </li>
                      <li class="blackColor">
                        <a
                          [href]="strSessionsTemplate"
                          target="_self"
                          (click)="$event.stopPropagation()"
                          class="mainTextColor d-flex w-100">
                          {{ "header.top_line.menu.sessionsTempl" | translate }}
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    *ngIf="user?.IsWorker && CompositeSesManPrivilegus"
                    class="blackColor">
                    <a [href]="getPersonalPageSessionManageUrl()"
                       target="_self"
                       (click)="$event.stopPropagation()">
                      {{"header.top_line.menu.sessionManOld" | translate}}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>

          <!-- OFFERS -->
          <li #offers *ngIf="user?.token && isAcceptableRole()">
            <div (click)="toggleMenu('offers')">
              {{ "btns.offers" | translate }}
            </div>
            <div *ngIf="activeMenu === 'offers'">
              <div class="flexContentColumn4 first-submenu">
                <ul class="flexContentColumn4">
                  <li #suboffers
                    *ngIf="(sections$ | async)?.length > 0">
                    <div class="blackColor flexContent8 pr-1 subItem"
                         (click)="toggleSubMenu('offersList')">
                      <span>{{ "header.top_line.menu.offers" | translate }}</span>
                      <i class="filtersArrow tr-rt90"></i>
                    </div>
                    <ul class="second-submenu offers"
                        *ngIf="activeSubMenu === 'offersList'">
                      <li class="blackColor" *ngFor="let section of (sections$ | async)">
                        <a
                          [attr.href]="getOffersManagementUrl(section.id)"
                          target="_self"
                          (click)="handleOfferClick($event, section.id)">
                          <span id="{{ section.id }}">{{ section.name }}</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li
                    class="blackColor"
                    *ngIf="
                      user?.IsWorker &&
                      (DemandOfferManagementModelsGetPrivilegus ||
                        DemandOfferManagementModelsEditPrivilegus)">
                    <a [href]="strModels"
                       target="_self"
                       (click)="$event.stopPropagation()"
                       class="mainTextColor d-flex w-100">
                      {{ "header.top_line.menu.modelBuilder" | translate }}
                    </a>
                  </li>
                  <li
                    class="blackColor"
                    *ngIf="
                      user?.IsWorker &&
                      (DemandOfferManagementRulesGetPrivilegus ||
                        DemandOfferManagementRulesEditPrivilegus)">
                    <a [href]="strRules"
                       target="_self"
                       (click)="$event.stopPropagation()"
                       class="mainTextColor d-flex w-100">
                      {{ "header.top_line.menu.rulesBuilder" | translate }}
                    </a>
                  </li>

                  <li #subArchive
                    *ngIf="this.user.IsWorker">
                    <div class="blackColor flexContent8 pr-1 jc-sb subItem"
                         (click)="toggleSubMenu('archive')">
                      <span>{{ "header.top_line.menu.archive" | translate }}</span>
                      <i class="filtersArrow tr-rt90"></i>
                    </div>
                    <ul
                      class="second-submenu archive"
                      *ngIf="activeSubMenu === 'archive'">
                      <li class="blackColor">
                        <a
                          [href]="getReportArchiveUrl()"
                          (click)="$event.stopPropagation()"
                          target="_self">
                          {{ "header.top_line.menu.unrealizedVolumes" | translate }}
                        </a>
                      </li>
                      <li
                        class="blackColor">
                        <a
                          [href]="getReportDealsUrl()"
                          (click)="$event.stopPropagation()"
                          target="_self">
                          {{ "header.top_line.menu.report-deals" | translate }}
                        </a>
                      </li>
                      <li
                        class="blackColor">
                        <a
                          [href]="getReportTradingUrl()"
                          (click)="$event.stopPropagation()"
                          target="_self">
                          {{"header.top_line.menu.report-trading-session-orders" | translate}}
                        </a>
                      </li>
                      <li
                        class="blackColor">
                        <a
                          [href]="strReportBiddingProcess"
                          (click)="$event.stopPropagation()"
                          target="_self">
                          {{"header.top_line.menu.report-bidding-process" | translate}}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </li>
          <li
            *ngIf="user?.token && isAcceptableRole()">
            <a [href]="strAuctions"
               target="_self"
               (click)="$event.stopPropagation()">
              {{ "header.top_line.menu.auctions" | translate }}
            </a>
          </li>
          <li
            *ngIf="
              (user?.token ||
                (user?.IsWorker && CompositeAdmissionPrivilegus)) &&
              isAcceptableRole()">
            <a
              [href]="getPersonalPageAdmissionUrl()"
              target="_self"
              (click)="$event.stopPropagation()">
              {{ "header.top_line.menu.admission" | translate }}
            </a>
          </li>
          <li *ngIf="user?.token">
            <a
              [href]="getPersonalPageIndexUrl()"
              target="_self"
              (click)="$event.stopPropagation()">
              {{ "header.top_line.menu.personalSection" | translate }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <div class="header_top-line__right d-flex">
      <div class="info_block user unauthorized">
        <div (click)="loginUAS()" id="user" #account>
          <span *ngIf="!authorized" class="text">
            <button class="btn btn-outline-primary submit">
              {{ "login_form.enter" | translate }}
            </button>
          </span>
          <ng-container *ngIf="authorized">
            <a
              [href]="getPersonalPageNotifyingUrl"
              (click)="$event.stopPropagation()">
              <ng-container
                *ngTemplateOutlet="notifying">
              </ng-container>
            </a>
            <span *ngIf="authorized" class="text">
              <div class="icon" (click)="toggleMenu('about'); $event.stopPropagation()"></div>
            </span>
          </ng-container>
        </div>
        <div *ngIf="authorized && activeMenu === 'about'" class="user__dropdown">
          <div class="logo-user-wrapper">
            <div class="logo"></div>
            <div class="user-company">
              <p class="font-s14 font-w500">
                {{ user.userInfo?.traderFullName }}
              </p>
            </div>
          </div>
          <div class="company">
            <span class="font-w500 font-s12" style="color: #787878"
              >Компания</span
            >
            <p class="p-0 mt-1 font-w600">{{ user?.userInfo?.firmName }}</p>
          </div>
          <div class="reg_number">
            <span class="font-w500 font-s12" style="color: #787878">{{
              "login_form.reg_number" | translate
            }}</span>
            <p class="p-0 mt-1 font-w600">{{ user.userInfo?.traderRegNum }}</p>
          </div>
          <div class="font-s12 secondTextColor l-h16" *ngIf="user.userInfo?.validTo">
            <i class="certificateIcon"></i>
            <span> {{ "login_form.certificateValidityPeriod" | translate }}</span>
            <span class="font-w500">
              {{ user.userInfo?.validTo
                  | excelDate : true
                  | date : "dd.MM.yyyy" : "+0000"
              }}
            </span>
          </div>
          <div (click)="logOut()" class="d-flex jc-c m-2 btn">
            <!--  -->
            <a>{{ "login_form.log-out" | translate }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
<ng-template #notifying>
  <svg width="32px" height="32px" viewBox="-2.8 -6.8 41.60 41.60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#424242" stroke="#424242" stroke-width="0.704"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="icomoon-ignore"> </g> <path d="M25.074 21.375v-8.568c0-4.462-3.229-8.162-7.474-8.915v-0.681c0-0.589-0.478-1.066-1.066-1.066h-1.066c-0.589 0-1.066 0.477-1.066 1.066v0.684c-4.237 0.761-7.453 4.458-7.453 8.912v8.568l-3.742 3.029v1.729h25.59v-1.729l-3.721-3.029zM27.729 25.066h-23.457v-0.154l3.742-3.029v-9.077c0-4.41 3.587-7.997 7.997-7.997 4.409 0 7.997 3.587 7.997 7.997v9.075l3.721 3.029v0.155z" fill="rgb(66, 66, 66)"> </path> <path d="M15.999 29.856c1.473 0 2.669-1.192 2.669-2.666h-5.335c0.001 1.473 1.195 2.666 2.667 2.666z" fill="rgb(66, 66, 66)"> </path> </g></svg>
</ng-template>
